class productByob extends HTMLElement {
    constructor() {
        super();
        this.subscriptionOnlyVariantIds = new Set();
        this.syncSubscriptionOnlyVariantIds();

        this.priceNodes = null;
        this.priceLoadingTargets = null;
        this.priceLoadingTriggers = [];
        this.priceLoadingTimer = null;
        this.priceLoadingTimeoutMs = 3500;
        this.priceState = null;

        this.productWrapperSelector = '[js-product-wrapper]';
        this.addToSetBtn = '[js-ats-btn]';
        this.addQtysBtn = '[js-qty-btn]';
        this.incrementBtnSelector = '[js-quantity-increment]';
        this.decrementBtnSelector = '[js-quantity-decrement]';
        this.quantityInputSelector = '[js-quantity-input]';
        this.productBundleCountBadge = '[js-product-bundle-count]';

        this.selectionCountWrapper = this.querySelector('[js-bundle-selection-count-wrap]');
        this.selectionCount = this.querySelector('[js-selection-count]');
        this.templateSuffix = document.body?.getAttribute('template') || '';
        this.isByob2LikeTemplate = this.templateSuffix === 'product-byob-2' || this.templateSuffix === 'superbellybestsellers-new' || this.templateSuffix === 'superbellybest-new-us' || this.templateSuffix === 'perimenopause';
        this.addToCartBtn = this.querySelector('[js-bundle-addToCart-btn]');
        this.sellingPlanSelect = this.querySelector('[js-byob-custom-option-select]');
        this.totalPrice = this.querySelectorAll('[js-total-price]');
        this.totalDiscountedPrice = this.querySelectorAll('[js-total-discounted-price]');
        this.currencyFormat = this.querySelector('[currency-format]').getAttribute('currency-format');
        this.oneTimePrice = this.querySelector('[onetime-price]').getAttribute('onetime-price');
        this.oneTimeStrikePrice = this.querySelector('[onetime-strike-price]').getAttribute('onetime-strike-price');
        this.subsciptionPrice = this.querySelector('[subsciption-price]').getAttribute('subsciption-price');
        this.subsciptionStrikePrice = this.querySelector('[subscription-strike-price]').getAttribute('subscription-strike-price');

        this.subscriptionDiscountedPriceEls = this.querySelectorAll('[js-skio-subsciption-discounded-price]');
        this.subscriptionTotalPriceEls = this.querySelectorAll('[js-skio-subsciption-total-price]');
        this.oneTimeTotalPriceEls = this.querySelectorAll('[js-skio-one-time-total-price]');

        this.products = [];
        this.sellingPlanId = this.sellingPlanSelect.value;
        this.sellingPlanName = null;
        this.servings = parseInt(this.querySelector('[js-onetime-per-serving]').getAttribute('data-serving-value')) || 0;

        this.oneTimeRadio = this.querySelector('[js-skio-bundle-onetime]');
        this.subscriptionRadio = this.querySelector('[js-skio-bundle-subscription]');
        this.selectField = this.querySelector('[js-skio-bundle-select-field]');

        this.setPriceLoading(true);
        this.startPriceLoadingTimeout();

        if (this.selectionCount) {
            this.selectionCount.innerHTML = skioDynamicBundleMinLimit;
        }

        this.handleSubscriptionToggle();

        document.addEventListener('skioBundlePrice:failed', () => {
            this.setPriceLoading(false);
        });

        document.addEventListener('skioBundlePrice:init', () => {
            if (this.isByob2LikeTemplate) {
                this.seedProductsFromGrid();
            }
            if (this.sellingPlanSelect && this.sellingPlanSelect.options.length > 0) {
                this.sellingPlanSelect.selectedIndex = 0;
                this.sellingPlanId = this.sellingPlanSelect.value;
                const selectedOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
                this.sellingPlanName = selectedOption?.getAttribute('data-plan-name') || null;
            }
            this.updatePrice();
            this.updateSubscriptionLocks();
            if (this.selectionCount) {
                this.selectionCount.innerHTML = this.isByob2LikeTemplate ? 0 : skioDynamicBundleMinLimit;
            }
            this.setPriceLoading(false);
        });

        this.addEventListener('click', (event) => {
            const lockedWrapper = event.target.closest(`${this.productWrapperSelector}.byob-subscription-locked`);
            if (lockedWrapper) {
                return;
            }
            
            this.querySelectorAll(this.addToSetBtn).forEach(addToSet => {
                if (addToSet.contains(event.target)) {
                    const parent = addToSet.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();
                    parent.classList.add('selected');
                    this.addProductToBox(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
                if (incrementBtn.contains(event.target)) {
                    const parent = incrementBtn.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();

                    this.addProductToBox(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
                if (decrementBtn.contains(event.target)) {
                    const parent = decrementBtn.closest(this.productWrapperSelector);
                    const currentProductId = Number(parent.dataset.productId);
                    const quantityField = parent.querySelector(this.quantityInputSelector);

                    if (Number(quantityField.value) > 0) {
                        quantityField.stepDown();
                    }

                    this.removeProductFromBox(currentProductId, parent);
                    this.updatePrice();
                }
            });

            this.sellingPlanId = this.sellingPlanSelect.value;
            if (this.sellingPlanSelect) {
                const initialOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
                this.sellingPlanName = initialOption?.getAttribute('data-plan-name') || null;
            }
        });
        

        this.sellingPlanSelect.addEventListener('change', (e) => {
            this.sellingPlanId = e.currentTarget.value;
            this.updatePrice();
            const selectedOption = e.target.options[e.target.selectedIndex];
            this.sellingPlanName = selectedOption.getAttribute('data-plan-name');
        });

        this.addToCartBtn.addEventListener('click', () => {
            let cartItems = [];
            if (this.sellingPlanSelect) {
                this.sellingPlanId = this.sellingPlanSelect.value;
                const selectedOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
                this.sellingPlanName = selectedOption?.getAttribute('data-plan-name') || null;
            }
            const isSubscription = this.subscriptionRadio?.checked;
            const groupIndex = new Date().getTime();
            const discountedPriceText = this.totalDiscountedPrice[0].innerText.replace('CAD', '').replace('USD', '');
            const originalPriceText = this.totalPrice[0].innerText || discountedPriceText;

            this.products.forEach(product => {
                const itemFound = cartItems.find(item => item.id === product.id);
                if (itemFound) {
                    cartItems = cartItems.map(item => {
                        if (item.id === product.id) {
                            item.quantity += product.quantity;
                        }
                        return item;
                    });
                } else {
                    const properties = {
                        _byobPurchaseType: isSubscription ? 'subscription' : 'onetime',
                        _productUrl: this.getAttribute('data-product-url'),
                    };

                    if (isSubscription) {
                        properties._dynamicBoxIndex = groupIndex;
                        properties._sellingPlanName = this.sellingPlanName;
                        properties._discountedPrice = discountedPriceText;
                        properties._originalPrice = originalPriceText || discountedPriceText;
                        properties._dynamicBoxId = typeof skioDynamicBoxId !== 'undefined' ? skioDynamicBoxId : '';
                    } else {
                        // properties._byobDisplayIndex = groupIndex;
                        properties._discountedPrice = discountedPriceText;
                        // properties._originalPrice = originalPriceText || discountedPriceText;
                        
                        properties._originalPrice = originalPriceText || discountedPriceText;
                        properties._sellingPlanName = null; 
                        properties._dynamicBoxIndex = groupIndex;
                    }

                    cartItems.push({
                        quantity: product.quantity,
                        id: product.id,
                        selling_plan: isSubscription ? this.sellingPlanId : null,
                        properties,
                    });
                }
            });

            console.log({ cartItems })

            this.addToCartBtn.classList.add('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
            this.addToCart(cartItems);
        });
    }

    updateServing(packSize){
        const servingElements = this.querySelectorAll('[js-skio-dynamic-bundle-serving]');
        servingElements.forEach(element => {
            element.innerText = this.servings * packSize;
        });
    }

    updateEachItemPriceInProgressBar(){  
        skioDynamicBundlesizeInterval.forEach(size => {
            const sizeTag = this.querySelector(`[js-bundle-pregress-bar-each-item-price][data-pack="${size}"]`);
            if(sizeTag) {
                 if (this.subscriptionRadio?.checked) {
                    sizeTag.innerText = `$${(skioDynamicBundlePrices[size]?.subscription.discountedPrice / size).toFixed(2)}`;
                 } else {
                    const otpDiscountAmount = this.getOneTimeDiscountAmount(size);
                    const otpBasePrice = skioDynamicBundlePrices[size]?.oneTime.originalPrice || 0;
                    const otpDiscounted = Math.max(otpBasePrice - otpDiscountAmount, 0);
                    sizeTag.innerText = `$${(otpDiscounted / size).toFixed(2)}`;
                 }
            }
        })
    }

    formatDiscountDisplay(value) {
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) return '';

        return Number.isInteger(numericValue) ? `$${numericValue}` : `$${numericValue}`;
    }

    formatDiscountDisplayPadded(value) {
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) return '';

        return Number.isInteger(numericValue) ? `$${numericValue}` : `$${numericValue.toFixed(2)}`;
    }
    
    getPriceNodes() {
        if (this.priceNodes) return this.priceNodes;

        this.priceNodes = {
            subscriptionDiscounted: this.querySelectorAll('[js-skio-subsciption-discounded-price]'),
            subscriptionTotal: this.querySelectorAll('[js-skio-subsciption-total-price]'),
            oneTimeTotal: this.querySelectorAll('[js-skio-one-time-total-price]'),
            total: this.totalPrice?.length ? this.totalPrice : document.querySelectorAll('[js-total-price]'),
            totalDiscounted: this.totalDiscountedPrice?.length ? this.totalDiscountedPrice : document.querySelectorAll('[js-total-discounted-price]'),
            promoContainers: this.querySelectorAll(
                '[js-price-promo-container] .promo-price-container, .product-price-container .promo-price-container'
            ),
            servings: this.querySelectorAll('[js-skio-dynamic-bundle-serving]'),
            oneTimePerServing: this.querySelector('[js-onetime-per-serving]'),
            subscriptionPerServing: this.querySelector('[js-subscription-per-serving]'),
            offerSavePrice: this.querySelector('[js-skio-bundle-offer-save-price]'),
            recurringDiscount: this.querySelector('[js-skio-subscription-recurring-discount]'),
            firstOrderDiscount: this.querySelector('[js-skio-subscription-first-order-discount]'),
            byobServings: document.querySelector('[js-byob-servings]'),
        };

        return this.priceNodes;
    }

    buildPriceState(packSize) {
        const tier = skioDynamicBundlePrices[packSize] || {};
        const eachPackText = this.getAttribute('data-each-pack-text');
        const currency = this.currencyFormat;

        const otpDiscountAmount = this.getOneTimeDiscountAmount(packSize);
        const otpOriginal = tier.oneTime?.originalPrice || 0;
        const otpDiscounted = Math.max(otpOriginal - otpDiscountAmount, 0);

        const subOriginal = Number(tier.subscription?.originalPrice) || 0;
        const subDiscounted = Number(tier.subscription?.discountedPrice) || 0;

        const isSubscription = Boolean(this.subscriptionRadio?.checked);
        const servingTotal = this.servings * packSize;

        return {
            packSize,
            currency,
            eachPackText,
            isSubscription,
            servingTotal,
            oneTime: {
                original: otpOriginal,
                discounted: otpDiscounted,
                discountAmount: otpDiscountAmount,
                perPack: otpDiscounted / packSize,
                originalPerPack: otpOriginal / packSize,
            },
            subscription: {
                original: subOriginal,
                discounted: subDiscounted,
                perPack: subDiscounted / packSize,
                unitPrice: Number(skioDynamicBundleVariantPrice) || 0,
                saveAmount: subOriginal - subDiscounted,
            },
            active: {
                price: isSubscription ? subDiscounted : otpDiscounted,
                compare: isSubscription ? subOriginal : (otpDiscountAmount > 0 ? otpOriginal : null),
            },
        };
    }

    writePriceState(state) {
        const nodes = this.getPriceNodes();
        const { currency, eachPackText, packSize } = state;

        const subscriptionPerPackText = `$${state.subscription.perPack.toFixed(2)} ${currency}/${eachPackText}`;
        const subscriptionUnitText = `$${state.subscription.unitPrice.toFixed(2)} `;
        const oneTimePerPackText = `$${state.oneTime.perPack.toFixed(2)} ${currency}/${eachPackText}`;
        const oneTimeOriginalPerPackText = `$${state.oneTime.originalPerPack.toFixed(2)}`;
        const activeDiscountedText = `$${state.active.price.toFixed(2)} ${currency}`;
        const activeCompareText = state.active.compare !== null ? `$${state.active.compare.toFixed(2)} ` : '';

        nodes.subscriptionDiscounted.forEach(el => { el.innerText = subscriptionPerPackText; });
        nodes.subscriptionTotal.forEach(el => { el.innerText = subscriptionUnitText; });

        nodes.oneTimeTotal.forEach(el => {
            if (state.oneTime.discountAmount > 0) {
                el.innerHTML = `<span>${oneTimePerPackText}</span> <s>${oneTimeOriginalPerPackText}</s>`;
            } else {
                el.innerText = oneTimePerPackText;
            }
        });

        nodes.totalDiscounted.forEach(el => { el.innerText = activeDiscountedText; });
        nodes.total.forEach(el => { el.innerText = activeCompareText; });

        nodes.promoContainers.forEach(container => {
            const promoPriceEl = container.querySelector('.promo-price');
            const promoCompareEl = container.querySelector('.promo-price-compare');

            if (promoPriceEl) promoPriceEl.innerText = activeDiscountedText;
            if (promoCompareEl) {
                promoCompareEl.innerText = state.active.compare !== null ? `$${state.active.compare.toFixed(2)} ${currency}` : '';
                promoCompareEl.style.display = state.active.compare !== null ? '' : 'none';
            }
        });

        nodes.servings.forEach(el => { el.innerText = state.servingTotal; });

        if (nodes.oneTimePerServing) {
            nodes.oneTimePerServing.innerText = `$${(state.oneTime.discounted / state.servingTotal).toFixed(2)}`;
        }
        if (nodes.subscriptionPerServing) {
            nodes.subscriptionPerServing.innerText = `$${(state.subscription.discounted / state.servingTotal).toFixed(2)}`;
        }

        if (nodes.offerSavePrice) {
            const bodyTemplate = document.body?.getAttribute('template') || '';
            if (bodyTemplate === 'product-byob-new') {
                const metafieldDiscountPercentage = this.getSubscriptionDiscountPercentage(packSize);
                const discountPercentage = Number.isFinite(metafieldDiscountPercentage)
                    ? metafieldDiscountPercentage
                    : ((state.subscription.saveAmount / state.subscription.original) * 100).toFixed(2);
                nodes.offerSavePrice.innerHTML = `${parseFloat(discountPercentage)}%`;
            } else {
                nodes.offerSavePrice.innerHTML = `$${state.subscription.saveAmount.toFixed(2)}`;
            }
        }

        if (nodes.recurringDiscount) {
            const tierRecurringDiscount = Number(skioSubscriptionRecurringDiscountTier?.[packSize]);
            if (Number.isFinite(tierRecurringDiscount)) {
                nodes.recurringDiscount.innerText = this.formatDiscountDisplayPadded(tierRecurringDiscount);
            }
        }

        if (nodes.firstOrderDiscount) {
            const tierFirstOrderDiscount = Number(skioSubscriptionFirstOrderDiscountTier?.[packSize]);
            if (Number.isFinite(tierFirstOrderDiscount)) {
                nodes.firstOrderDiscount.innerText = this.formatDiscountDisplayPadded(tierFirstOrderDiscount);
            }
        }

        if (nodes.byobServings?.style) {
            nodes.byobServings.style.opacity = 1;
        }

        this.updateEachItemPriceInProgressBar();
    }

    updatePrice() {
        const packSize = this.products?.length > skioDynamicBundleMinLimit ? this.products.length : skioDynamicBundleMinLimit;

        if (!this.isPriceReady(packSize)) {
            return;
        }

        this.priceState = this.buildPriceState(packSize);
        this.writePriceState(this.priceState);
        this.setPriceLoading(false);
    }

    isPriceReady(packSize) {
        const priceData = skioDynamicBundlePrices?.[packSize];
        if (!priceData) return false;
        const sub = priceData.subscription?.discountedPrice;
        const otp = priceData.oneTime?.originalPrice;
        return Number.isFinite(Number(sub)) || Number.isFinite(Number(otp));
    }

    getPriceLoadingTargets() {
        if (!this.priceLoadingTargets) {
            this.priceLoadingTargets = [
                ...document.querySelectorAll('[js-price-display]'),
                ...this.querySelectorAll('.skio-price, .skio-budle__price--wrapper'),
                ...this.querySelectorAll('.bundle-atc-button .single-add-to-cart-button--price-wrap'),
            ];
            this.priceLoadingTriggers = [...document.querySelectorAll('.price_trigger')].filter(
                node => node.querySelector('[js-price-display]')
            );
        }

        return this.priceLoadingTargets;
    }

    setPriceLoading(isLoading) {
        if (!isLoading) {
            clearTimeout(this.priceLoadingTimer);
            this.priceLoadingTimer = null;
        }

        this.getPriceLoadingTargets().forEach(el => {
            el.classList.toggle('price--loading', isLoading);
        });
        this.priceLoadingTriggers.forEach(el => {
            el.classList.toggle('price--loading', isLoading);
        });

        // The sticky bar builds its price nodes lazily, so it can't be captured in
        // the cached list above. It reads the loading state off the body instead.
        document.body.classList.toggle('byob-price-loading', isLoading);
    }

    startPriceLoadingTimeout(delay = this.priceLoadingTimeoutMs) {
        clearTimeout(this.priceLoadingTimer);
        this.priceLoadingTimer = setTimeout(() => {
            // Skio is slow or unreachable: drop the skeleton and leave the
            // Liquid-rendered one-time price visible rather than shimmering forever.
            this.setPriceLoading(false);
        }, delay);
    }

    getOneTimeDiscountAmount(packSize) {
        const sizeKey = Number(packSize) || 0;
        return oneTimeFixedDiscountTier?.[sizeKey] ? Number(oneTimeFixedDiscountTier[sizeKey]) : 0;
    }
    getSubscriptionDiscountPercentage(packSize) {
        const sizeKey = Number(packSize) || 0;
        if (typeof subscriptionFixedDiscountPercentageTier === 'undefined') {
            return NaN;
        }
        if (typeof subscriptionFixedDiscountPercentageArray === 'undefined' || !subscriptionFixedDiscountPercentageArray.length) {
            return NaN;
        }

        const discountPercentage = subscriptionFixedDiscountPercentageTier?.[sizeKey];
        if (discountPercentage === undefined || discountPercentage === null || discountPercentage === '') {
            return NaN;
        }

        return Number(String(discountPercentage).replace('%', ''));
    }

    addProductToBox(parent) {
        const imageUrl = parent.dataset.productImageUrl;
        const variantId = Number(parent.dataset.variantId);
        const productId = Number(parent.dataset.productId);
        const title = parent.dataset.productTitle;
        const price = Number(parent.dataset.productPrice);
        const customPrice = Number(parent.dataset.productCustomPrice) || 0;

        this.products.push({
            id: variantId,
            productId: productId,
            imageUrl,
            title,
            price,
            customPrice,
            quantity: 1,
        });

        this.updateStatus();
    }
    removeProductFromBox(id, parent) {
        const otherProducts = this.products.filter(product => product.productId !== id);
        const currentProducts = this.products.filter(product => product.productId == id);
        currentProducts.splice(0, 1);

        if (currentProducts.length === 0) {
            parent.classList.remove('selected');
        }

        this.products = [...currentProducts, ...otherProducts];
        this.updateStatus();
    }
    seedProductsFromGrid() {
        if (!this.isByob2LikeTemplate) {
            return;
        }
        this.products = Array.isArray(window.byobBundleItems) ? window.byobBundleItems.map(item => ({
            id: item.id,
            productId: item.productId,
            imageUrl: item.imageUrl,
            title: item.title,
            price: item.price,
            customPrice: item.customPrice,
            quantity: 1,
        })) : [];

        this.updateStatus();
    }
    updateStatus() {
        if (this.products.length >= skioDynamicBundleMinLimit) {
            this.addToCartBtn.classList.add('is-visible');
            if (this.selectionCountWrapper) {
                this.selectionCountWrapper.classList.remove('is-visible');
            }
        } else {
            this.addToCartBtn.classList.remove('is-visible');
            if (this.selectionCountWrapper) {
                this.selectionCountWrapper.classList.add('is-visible');
            }
        }
        if (this.products.length >= skioDynamicBundleMaxLimit) {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.add('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.add('disabled'));
        } else {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.remove('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.remove('disabled'));
        }
        const productCount = this.products.length;

        this.progressBars = this.querySelectorAll('[js-progress-bar-pack]');
        this.progressBars.forEach((bar) => {
            const pack = parseInt(bar.dataset.pack);
            if (pack <= productCount) {
                bar.classList.add('selected');
            } else {
                bar.classList.remove('selected');
            }
        });

        const selectedPacks = this.querySelectorAll('[js-progress-bar-pack].selected');
        const progressBarValue = this.querySelector('[js-bundle-progress-bar-value]');
        if (selectedPacks.length && progressBarValue) {
            const index = parseInt(selectedPacks[selectedPacks.length - 1]?.getAttribute('data-index'));
            progressBarValue.style.width = `${index * 50}%`;
        } else if (progressBarValue) {
            progressBarValue.style.width = '0%';
        }
        if (this.selectionCount) {
            this.selectionCount.innerHTML = `${skioDynamicBundleMinLimit - this.products.length}`;
        }
    }
    updateProductCountBadge(parent) {
        const quantityField = parent.querySelector(this.quantityInputSelector);
        const badge = parent.querySelector(this.productBundleCountBadge);
        const qty = Number(quantityField.value);

        if (qty >= 1) {
            badge.classList.remove('hidden');
            badge.innerText = qty;
        } else {
            badge.classList.add('hidden');
            badge.innerText = 0;
        }
    }
    handleSubscriptionToggle() {
        if (!this.oneTimeRadio || !this.subscriptionRadio || !this.selectField) return;

        const toggleVisibility = () => {
            // if (this.subscriptionRadio.checked) {
            //     this.selectField.style.maxHeight = "1000px";
            //     this.selectField.style.opacity = "1";
            //     this.selectField.style.visibility = "visible";

            // } else if (this.oneTimeRadio.checked) {
            //     this.selectField.style.maxHeight = "0px";
            //     this.selectField.style.opacity = "0";
            //     this.selectField.style.visibility = "hidden";
            // }

            this.updateSubscriptionLocks();
            this.updatePrice();
        };

        this.selectField.addEventListener('click', () => {
            if (this.subscriptionRadio.checked) return;
            this.subscriptionRadio.checked = true;
            this.subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
        });

        toggleVisibility();
        this.oneTimeRadio.addEventListener("change", toggleVisibility);
        this.subscriptionRadio.addEventListener("change", toggleVisibility);
    }
    updateSubscriptionLocks() {
        if (!['product-byob', 'product-byob-new', 'product-byob-us'].includes(this.templateSuffix)) {
            return;
        }
        this.syncSubscriptionOnlyVariantIds();

        const isOneTimeSelected = this.oneTimeRadio?.checked;
        const wrappers = this.querySelectorAll(this.productWrapperSelector);
        let removedLockedItems = false;

        wrappers.forEach((wrapper) => {
            const variantId = String(wrapper.dataset.variantId || '');
            const requiresSubscriptionOnly = wrapper.dataset.requiresSubscriptionOnly === 'true'
                || this.subscriptionOnlyVariantIds.has(variantId);
            const shouldLock = Boolean(isOneTimeSelected && requiresSubscriptionOnly);
            const shouldHighlightSubscription = Boolean(!isOneTimeSelected && requiresSubscriptionOnly);

            wrapper.classList.toggle('byob-subscription-locked', shouldLock);
            wrapper.classList.toggle('byob-subscription-highlight', shouldHighlightSubscription);

            if (shouldLock) {
                const quantityField = wrapper.querySelector(this.quantityInputSelector);
                if (quantityField && Number(quantityField.value) > 0) {
                    quantityField.value = 0;
                    wrapper.classList.remove('selected');
                    removedLockedItems = true;
                }
            }
        });

        if (removedLockedItems) {
            this.products = this.products.filter((product) => {
                return !this.subscriptionOnlyVariantIds.has(String(product.id));
            });
            this.updateStatus();
        }
    }
    syncSubscriptionOnlyVariantIds() {
        const dynamicSubscriptionOnlyVariantIds = Array.isArray(window.byobSubscriptionOnlyVariantIds)
            ? window.byobSubscriptionOnlyVariantIds
            : [];
        this.subscriptionOnlyVariantIds = new Set(dynamicSubscriptionOnlyVariantIds.map((id) => String(id)));
    }
    async addToCart(products) {
        const requestBody = { items: products };

        try {
            const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: { "Content-Type": "application/json" },
            });

            const data = await resp.json();

            document.dispatchEvent(new CustomEvent("cart:refresh"));
            if (document.getElementById('Cart-Drawer')) {
                document.body.classList.add('open-cc', 'open-cart');
                document.getElementById('Cart-Drawer').classList.add('active');
            }

            this.addToCartBtn.classList.remove('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.add('hidden');
        } catch (err) {
            console.error({ err });
        }
    }
}

customElements.define('product-byob', productByob);
